// extracted by mini-css-extract-plugin
module.exports = {"bottomBar":"BottomBar_bottomBar__2GfZ0","bottomBarDate":"BottomBar_bottomBarDate__3Zvk8"};